import lodashGet from 'lodash/get';
import lodashGroupby from 'lodash/groupBy';
import lodashOrderBy from 'lodash/orderBy';
import { inWindow } from '@/config';
import { util } from '@/api/util';
import { contactCommonConditionFilterName, contactCommonSearchFilterName, contactCommonTypeFilter, contactExcludeSelfFilterName, contactGrepInvalidEnterpriseFilterName, contactGrepRelateEnterpriseFilterName, contactIMFilterName, contactMultiTypeFilterName, contactOrgIdEqTeamFilterName, contactOrgIdNeqPersonOrgFilterName, contactOrgIdNeqTeamFilterName, } from '@/api/logical/contact_constants';
import lodashChunk from 'lodash/chunk';
import { readLxInfoFromLoki } from './contact_sync_enterprise_loki';
import { contactSearchDbName } from './util/const';
export class ContactDBSearch {
    constructor(ctx) {
        this.ctx = ctx;
        this.contactLastUpdateTimMap = {};
        this.enablePutContact = true;
    }
    getContactWritePriority() {
        return this.enablePutContact;
    }
    setEnablePutContact(val) {
        this.enablePutContact = val;
    }
    getContactLastUpdateTime(_account = this.ctx.contactUtil.getCurrentAccount()) {
        return this.contactLastUpdateTimMap[_account] || 0;
    }
    setContactLastUpdateTime(_account = this.ctx.contactUtil.getCurrentAccount()) {
        this.contactLastUpdateTimMap[_account] = Date.now();
    }
    repackageQueryConfigByRelateEnterpriseInfo(_queryConfig, noRelateEnterprise = false, enterpriseFieldName = 'enterpriseId') {
        if (!noRelateEnterprise || (inWindow() && window.isAccountBg)) {
            return _queryConfig;
        }
        const queryConfig = Object.assign({}, _queryConfig);
        if (queryConfig.filter && queryConfig.filter.length) {
            queryConfig.filter =
                typeof queryConfig.filter === 'string'
                    ? [queryConfig.filter, contactGrepRelateEnterpriseFilterName]
                    : [...queryConfig.filter, contactGrepRelateEnterpriseFilterName];
        }
        queryConfig.additionalData = Object.assign(Object.assign({}, queryConfig.additionalData), { needGrepRelateEnterpriseResult: true, enterpriseFieldName });
        return queryConfig;
    }
    setDataOrder(params) {
        const { orderBy, data, query } = params;
        if (!Array.isArray(data) || !data.length || !Array.isArray(orderBy) || !orderBy.length) {
            return data;
        }
        const iteratees = [];
        const orders = [];
        orderBy.forEach((orderItem) => {
            const orderItemArr = (Array.isArray(orderItem) ? orderItem : [orderItem, true]);
            if (orderItemArr.length < 2) {
                return;
            }
            const [field, isAsc = false] = orderItemArr;
            if (typeof query === 'string' && query.length) {
                iteratees.push((o) => {
                    const str = lodashGet(o, field, '');
                    return typeof str === 'string' && str.includes(query) ? str.indexOf(query) : Infinity;
                });
            }
            else {
                iteratees.push(field);
            }
            orders.push(isAsc ? 'asc' : 'desc');
        });
        return lodashOrderBy(data, iteratees, orders);
    }
    async getContactList(params) {
        const { idList, contactType, showDisable = true, isIM, exclude, orderByItem: orderBy, _account, needLog, noRelateEnterprise, needOrder = true } = params;
        if (!contactType) {
            if (!idList) {
                return Promise.reject(new Error('必须传入idList,或者contactType'));
            }
            if (!idList.length) {
                console.error('[contact_dbl] getContactList error', idList);
                return [];
            }
        }
        let adCondition;
        const includeOption = [];
        const excludeOption = exclude || [];
        if (contactType && (!idList || idList.length === 0)) {
            adCondition = {
                type: 'equals',
                args: [contactType],
                field: 'type',
            };
        }
        if (idList && idList.length > 0) {
            adCondition = {
                type: 'anyOf',
                args: [idList],
                field: 'id',
            };
            if (contactType) {
                includeOption.push({ key: 'type', val: contactType });
            }
        }
        if (isIM) {
            includeOption.push({ key: 'enableIM', val: true });
        }
        if (!showDisable) {
            includeOption.push({ key: 'visibleCode', val: 0 });
        }
        let res = [];
        try {
            if (needLog) {
                console.warn('[contact_tree] doGetPersonalContact start', _account);
            }
            const queryConfig = this.repackageQueryConfigByRelateEnterpriseInfo({
                dbName: this.ctx.contactUtil.contactDbName,
                tableName: this.ctx.contactUtil.contactTable,
                adCondition,
                additionalData: {
                    includeOption,
                    excludeOption,
                    parentName: needLog ? 'doGetPersonalContact' : '',
                },
                filter: contactCommonConditionFilterName,
                useDexieFilter: false,
                _dbAccount: _account,
            }, noRelateEnterprise);
            res = (await this.ctx.dbApi.getByRangeCondition(queryConfig));
            if (needLog) {
                console.warn('[contact_tree] doGetPersonalContact end', _account);
            }
        }
        catch (error) {
            console.error('[contact] getContactList', error, params);
        }
        if ((res && res.length <= 1000) || needOrder) {
            res = this.setDataOrder({
                data: res,
                orderBy: orderBy || ['contactLabel', 'contactPYName', 'contactName'],
            });
        }
        return res;
    }
    async getPersonalContactByEmails(emails, _account) {
        const contactModelList = (await this.getContactByItem({
            type: 'EMAIL',
            filterType: 'personal',
            value: emails,
            _account,
        }));
        return contactModelList;
    }
    async getOrgList(params, returnEmptyWhenNoIdList) {
        params = params || {};
        const { idList, typeList, originIdList, showSearchable, isIM, exclude, needLog, orderByItem: orderBy, _account, needOrder = true } = params;
        let adCondition;
        const includeOption = [];
        const excludeOption = exclude || [];
        if (!!returnEmptyWhenNoIdList && ((originIdList === null || originIdList === void 0 ? void 0 : originIdList.length) === 0 || (idList === null || idList === void 0 ? void 0 : idList.length) === 0)) {
            return Promise.resolve([]);
        }
        if (originIdList === null || originIdList === void 0 ? void 0 : originIdList.length) {
            adCondition = {
                type: 'anyOf',
                args: [originIdList],
                field: 'originId',
            };
            includeOption.push({ key: 'type', val: 0 });
        }
        if (idList === null || idList === void 0 ? void 0 : idList.length) {
            adCondition = {
                type: 'anyOf',
                args: [idList],
                field: 'id',
            };
            if (originIdList) {
                includeOption.push({ key: 'originId', val: originIdList });
            }
        }
        if (isIM) {
            excludeOption.push({ key: 'type', val: [1, 2, 2001] });
        }
        if (showSearchable) {
            includeOption.push({ key: 'visibleCode', val: [0, 7] });
        }
        else {
            includeOption.push({ key: 'visibleCode', val: 0 });
        }
        if (typeList) {
            includeOption.push({ key: 'type', val: typeList });
        }
        let res = [];
        try {
            if (needLog) {
                console.warn('[contact_tree] getOrgList start ', _account);
            }
            res = (await this.ctx.dbApi.getByRangeCondition({
                dbName: contactSearchDbName,
                tableName: this.ctx.contactUtil.orgTable,
                adCondition,
                additionalData: {
                    includeOption,
                    excludeOption,
                    parentName: needLog ? 'getOrgList' : '',
                },
                filter: contactCommonConditionFilterName,
                useDexieFilter: false,
                _dbAccount: _account,
            }));
        }
        catch (error) {
            console.error('getOrgListError', error);
        }
        if (needOrder) {
            res = this.setDataOrder({
                data: res,
                orderBy: orderBy || [['orgRank', false]],
            });
        }
        return res;
    }
    async getOrgContactList(condition) {
        const { idList, type, includeType, filterPersonalOrg, filterTeamOrg, filterOrg, needGroup, needContactData, needContactModelData, filterSelf, orderBy, _account } = condition;
        let adCondition;
        const filter = [];
        const additionalData = {};
        if (idList === null || idList === void 0 ? void 0 : idList.length) {
            adCondition = {
                type: 'anyOf',
                args: [idList],
                field: type,
            };
        }
        if (filterTeamOrg) {
            filter.push(contactOrgIdNeqTeamFilterName);
        }
        if (filterOrg) {
            filter.push(contactOrgIdEqTeamFilterName);
        }
        if (filterPersonalOrg) {
            filter.push(contactOrgIdNeqPersonOrgFilterName);
        }
        const user = this.ctx.systemApi.getCurrentUser();
        if (filterSelf && (user === null || user === void 0 ? void 0 : user.contact)) {
            const contactId = user.contact.contact.id;
            additionalData.contactId = contactId;
            filter.push(contactExcludeSelfFilterName);
        }
        let list = [];
        let res = [];
        try {
            if (type === 'orgId' && includeType) {
                list = (await this.ctx.dbApi.getByRangeCondition({
                    adCondition: {
                        field: type,
                        args: [includeType],
                        type: 'startsWith',
                    },
                    tableName: this.ctx.contactUtil.orgContactTable,
                    dbName: this.ctx.contactUtil.contactDbName,
                    additionalData,
                    filter,
                    useDexieFilter: false,
                    _dbAccount: _account,
                }));
            }
            else if (adCondition) {
                list = (await this.ctx.dbApi.getByRangeCondition({
                    adCondition,
                    tableName: this.ctx.contactUtil.orgContactTable,
                    dbName: this.ctx.contactUtil.contactDbName,
                    additionalData,
                    filter,
                    useDexieFilter: false,
                    _dbAccount: _account,
                }));
            }
            else {
                return [];
            }
        }
        catch (e) {
            console.error('[contact] getOrgContactList', e, condition);
        }
        if (list.length) {
            if (needContactData || needContactModelData) {
                const contactId = util.getKeyListByList(list, 'contactId', true);
                list = await this.orgContactListHandleContact(contactId, list, !!needContactModelData);
            }
            if (orderBy) {
                list = this.setDataOrder({ data: list, orderBy });
            }
            if (needGroup && (idList === null || idList === void 0 ? void 0 : idList.length)) {
                res = this.orgContactListHandleGroup(idList, list, type);
            }
            else {
                res = list;
            }
        }
        return res;
    }
    orgContactListHandleGroup(idList, list, key) {
        return idList.map(id => list.filter(item => item[key] === id));
    }
    async orgContactListHandleContact(contactIdList, orgContactList, isAll) {
        const contactList = await this.getContactList({ idList: contactIdList });
        if (isAll) {
            const contactModelList = await this.handleContactList({
                contactList,
                orderByIdList: contactIdList,
            });
            const contactModelMap = contactModelList.reduce((modelMap, item) => {
                var _a;
                const contactId = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.id;
                if (contactId) {
                    if (!modelMap.contactId) {
                        modelMap[contactId] = item;
                    }
                }
                return modelMap;
            }, {});
            return orgContactList.map(item => {
                item.model = contactModelMap[item.contactId];
                return item;
            });
        }
        const contactListMap = util.listToMap(contactList, 'id');
        return orgContactList.map(item => {
            item.contact = contactListMap[item.contactId];
            return item;
        });
    }
    getOrgContactListByContactId(params) {
        var _a;
        const { idList, filterTeamOrg, _account = ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '' } = params;
        return this.getOrgContactList({
            idList,
            type: 'contactId',
            filterTeamOrg,
            _account,
        });
    }
    async getOrgContactListByOrgId(idList, _account) {
        return (await this.getOrgContactList({
            idList,
            type: 'orgId',
            _account,
        }));
    }
    async getContactItemListByItem(list) {
        let contactItemList = [];
        try {
            if (!(list === null || list === void 0 ? void 0 : list.length)) {
                return [];
            }
            const adCondition = {
                type: 'anyOf',
                args: [list],
                field: 'contactItemVal',
            };
            contactItemList = (await this.ctx.dbApi.getByRangeCondition({
                adCondition,
                dbName: this.ctx.contactUtil.contactDbName,
                tableName: this.ctx.contactUtil.contactItemTable,
            }));
        }
        catch (e) {
            console.error('[contact] getContactIdListByItem', e, list);
        }
        return contactItemList;
    }
    async getContactItemListByContactId({ idList = [], _account = this.ctx.contactUtil.getCurrentAccount() }) {
        if (idList === null || idList === void 0 ? void 0 : idList.length) {
            const adCondition = {
                type: 'anyOf',
                field: 'contactId',
                args: [idList],
            };
            console.time('[optimize]contactApi-searchContactFetchItem:' + idList.length);
            const res = (await this.ctx.dbApi.getByRangeCondition({
                adCondition,
                dbName: this.ctx.contactUtil.contactDbName,
                tableName: this.ctx.contactUtil.contactItemTable,
                _dbAccount: _account,
            }));
            console.timeEnd('[optimize]contactApi-searchContactFetchItem:' + idList.length);
            return res;
        }
        return [];
    }
    async getContactItemListByType(contactType) {
        const res = await this.ctx.dbApi.getByEqCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.contactItemTable,
            additionalData: {
                contactType,
            },
            filter: contactCommonTypeFilter,
            useDexieFilter: false,
        });
        return res;
    }
    async getPersonalOrg(params) {
        const { idList = [] } = params;
        let adCondition;
        params._account = params._account || this.ctx.contactUtil.getCurrentAccount();
        if (Array.isArray(idList) && idList.length) {
            adCondition = {
                type: 'anyOf',
                field: 'id',
                args: [idList],
            };
        }
        else {
            adCondition = {
                type: 'startsWith',
                field: 'id',
                args: ['personal_org'],
            };
        }
        let personalOrgList = await this.ctx.dbApi.getByRangeCondition({
            adCondition,
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.orgTable,
            _account: params._account,
            asSoon: true,
        });
        personalOrgList = util.setDataOrder({
            data: personalOrgList,
            orderBy: ['orgPYName', 'orgName'],
        });
        return personalOrgList;
    }
    async queryPersonalMemberCount(ids, account) {
        var _a, _b;
        if (!ids || !ids.length) {
            return {};
        }
        const orgContactList = await this.ctx.lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: this.ctx.contactUtil.orgContactTable,
            adCondition: {
                field: 'orgId',
                type: 'anyOf',
                args: [ids],
            },
            _account: account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
        });
        if (!orgContactList || !orgContactList.length) {
            return {};
        }
        const contactIds = orgContactList.map(item => item.contactId);
        const entityContactList = await this.ctx.lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: this.ctx.contactUtil.contactTable,
            _account: account || ((_b = this.ctx.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || '',
            adCondition: {
                type: 'anyOf',
                field: 'id',
                args: [contactIds],
            },
        });
        const entityContactSet = new Set(entityContactList.map(item => item.id));
        const groupMap = new Map();
        orgContactList.forEach(item => {
            const { orgId, contactId } = item;
            if (entityContactSet.has(contactId)) {
                groupMap.set(orgId, (groupMap.get(orgId) || 0) + 1);
            }
        });
        return Object.fromEntries(groupMap);
    }
    async getContactSearchCount(_account) {
        const _dbAccount = _account || this.ctx.contactUtil.getCurrentAccount();
        return this.ctx.dbApi.getTableCount({
            dbName: 'contact_search',
            tableName: 'contact',
            _dbAccount,
        });
    }
    getColor(email) {
        return util.getColor(email);
    }
    async getAllContactList(account) {
        const contactList = (await this.ctx.dbApi.getByRangeCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.contactTable,
            _dbAccount: account,
        }));
        return this.handleContactList({ contactList });
    }
    async getAllOrgContactList(account) {
        const contactList = await this.ctx.dbApi.getByRangeCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.orgContactTable,
            _dbAccount: account,
        });
        return contactList;
    }
    async getOrgData(idList, _account) {
        const res = await this.getOrgContactListByContactId({
            idList,
            filterTeamOrg: true,
            _account,
        });
        const orgContact = util.getGroupListByItem(res, 'contactId', 'orgId');
        const orgContactIdList = orgContact.objectKeyArray;
        const orgContactIdMap = orgContact.objectKeyMap;
        const orgList = await this.getOrgList({
            idList: orgContact.listKeyArray,
            _account,
        });
        const orgData = util.listToMap(orgList, 'id');
        orgContactIdList.forEach((contactId) => {
            const currentOrgContactIdList = orgContactIdMap[contactId];
            orgContactIdMap[contactId] = currentOrgContactIdList.map((item) => orgData[item.orgId]);
        });
        return orgContactIdMap;
    }
    async handleContactList(params) {
        const { contactList = [], orderByIdList, needOrgData, _account = this.ctx.contactUtil.getCurrentAccount() } = params;
        if (!contactList) {
            return [];
        }
        const idList = orderByIdList || util.getKeyListByList(contactList, 'id');
        if (idList.length === 0) {
            return [];
        }
        const promiseList = [];
        promiseList.push(this.getContactItemListByContactId({ idList, _account }));
        if (needOrgData) {
            promiseList.push(this.getOrgData(idList, _account));
        }
        const data = await Promise.all(promiseList);
        const contactInfoList = data[0];
        const orgData = needOrgData ? data[1] : undefined;
        return this.ctx.contactTrans.transformContactModel({
            orderByIdList: idList,
            contactInfoList,
            contactList,
            orgData,
            _account,
        });
    }
    async getContactsInMemoryMode(param) {
        const _dbAccount = param._account || this.ctx.contactUtil.getCurrentAccount();
        const fieldsMap = {
            email: 'accountName',
            yunxin: 'yunxinId',
            contactId: 'id',
        };
        if (param.type && !Object.keys(fieldsMap).includes(param.type)) {
            return Promise.reject(new Error('ony support email and yunxin'));
        }
        const type = param.type || 'email';
        let { fields } = param;
        if (type === 'email') {
            fields = fields.map(item => item.toLocaleLowerCase());
        }
        if (!(fields === null || fields === void 0 ? void 0 : fields.length)) {
            console.error('[contact_dbl] getContactsInMemoryMode error fields null');
            return [];
        }
        const conditionType = fieldsMap[type];
        const list = await this.ctx.dbApi.getByRangeCondition({
            dbName: 'contact_search',
            tableName: 'contact',
            adCondition: {
                type: 'anyOf',
                field: conditionType,
                args: [fields],
            },
            _dbAccount,
        });
        const validContactModelMap = new Map();
        list.forEach(contact => {
            var _a;
            if (contact.type !== 'enterprise') {
                validContactModelMap.set(contact.id, contact);
                return;
            }
            const key = `enterprise+${contact.accountName}`;
            if (!validContactModelMap.has(key)) {
                validContactModelMap.set(key, contact);
            }
            else if (((_a = validContactModelMap.get(key)) === null || _a === void 0 ? void 0 : _a.visibleCode) !== 0 && contact.visibleCode === 0) {
                validContactModelMap.set(key, contact);
            }
        });
        const contacts = [...validContactModelMap.values()];
        const contactIds = contacts.map(c => c.id);
        if (contactIds.length) {
            try {
                const lxInfoRows = await readLxInfoFromLoki(this.ctx.lokiApi, contactIds, _dbAccount);
                const lxInfoMap = new Map();
                lxInfoRows.forEach(row => lxInfoMap.set(row.contactId, row));
                contacts.forEach(contact => {
                    const lxInfo = lxInfoMap.get(contact.id);
                    if (lxInfo === null || lxInfo === void 0 ? void 0 : lxInfo.avatar) {
                        contact.avatar = lxInfo.avatar;
                    }
                });
            }
            catch (e) {
                console.warn('[contact_dbl_search] getContactsInMemoryMode lxInfo enrichment error', e);
            }
        }
        return contacts;
    }
    async getPersonalContactsFromMemory(orgId, _account) {
        const _dbAccount = _account || this.ctx.contactUtil.getCurrentAccount();
        try {
            const list = await this.ctx.dbApi.getByRangeCondition({
                dbName: 'contact_search',
                tableName: 'contact',
                adCondition: {
                    type: 'equals',
                    field: 'type',
                    args: ['personal'],
                },
                _dbAccount,
            });
            if (!list || !list.length) {
                return [];
            }
            if (!orgId || orgId === this.ctx.contactUtil.StaticNodeKey.PERSON_ALL) {
                const deduped = new Map();
                list.forEach(item => deduped.set(item.id, item));
                return [...deduped.values()];
            }
            const dedupedList = new Map();
            list.forEach(item => dedupedList.set(item.id, item));
            const uniqueList = [...dedupedList.values()];
            if (orgId.startsWith('personal_org_')) {
                return uniqueList.filter(item => {
                    var _a;
                    const personalOrg = (_a = item.info) === null || _a === void 0 ? void 0 : _a.personalOrg;
                    if (Array.isArray(personalOrg)) {
                        return personalOrg.includes(orgId);
                    }
                    return personalOrg === orgId;
                });
            }
            return uniqueList.filter(item => {
                var _a;
                const personalOrg = (_a = item.info) === null || _a === void 0 ? void 0 : _a.personalOrg;
                return !personalOrg || (Array.isArray(personalOrg) && personalOrg.length === 0);
            });
        }
        catch (e) {
            console.warn('[contact_dbl_search] getPersonalContactsFromMemory error', e);
            return [];
        }
    }
    transformMemoryModel2StandardModel(item, options) {
        var _a, _b, _c, _d, _e, _f;
        const info = item.info || {};
        const externalYunxinId = options === null || options === void 0 ? void 0 : options.yunxinId;
        const contact = {
            id: item.id,
            accountStatus: (_a = info.status) !== null && _a !== void 0 ? _a : 0,
            accountVisible: 1,
            contactLabel: item.contactPYLabelName.slice(0, 1) || '',
            contactPYLabelName: item.contactPYLabelName,
            contactPYName: item.contactPYName,
            contactName: item.contactName,
            accountName: item.accountName,
            enterpriseId: (_b = item.enterpriseId) !== null && _b !== void 0 ? _b : 0,
            accountOriginId: '',
            enableIM: externalYunxinId ? true : !!((_c = info.enableIM) !== null && _c !== void 0 ? _c : false),
            type: item.type,
            position: item.position,
            avatar: item.avatar,
            avatarPendant: item.avatarPendant,
            visibleCode: item.visibleCode,
            updateTime: 0,
            accountType: 2,
            displayEmail: item.accountName,
            accountId: `${item.accountName}_${item.id}`,
            dataSource: 'loki',
            job: info.job || '',
            mobile: info.mobile || '',
            gender: info.gender || '',
            state: info.state || '',
            tel: info.tel || '',
            remark: info.remark || '',
            personalOrg: info.personalOrg || '',
            birthday: info.birthday || '',
            role: info.role || '',
            title: info.title || '',
            org: info.org || '',
            orgname: info.orgname || '',
            adrList: info.adrList || [],
            pref: (_d = info.pref) !== null && _d !== void 0 ? _d : 0,
            priority: (_e = info.priority) !== null && _e !== void 0 ? _e : 0,
            marked: (_f = info.marked) !== null && _f !== void 0 ? _f : false,
            color: util.getColor(item.accountName),
        };
        const contactItemList = [
            {
                id: '',
                contactItemVal: item.accountName,
                contactItemRefer: '',
                contactItemType: 'EMAIL',
                isDefault: 1,
                type: item.type,
                contactId: item.id,
                emailType: 1,
            },
        ];
        (item.emails || []).forEach(email => {
            contactItemList.push({
                id: '',
                contactItemVal: email,
                contactItemRefer: '',
                contactItemType: 'EMAIL',
                isDefault: 0,
                type: item.type,
                contactId: item.id,
                emailType: 1,
            });
        });
        const yunxinVal = externalYunxinId || (info.enableIM ? item.yunxinId : undefined);
        if (yunxinVal && item.type === 'enterprise') {
            contactItemList.push({
                id: '',
                contactItemVal: yunxinVal,
                contactItemRefer: '',
                contactItemType: 'yunxin',
                isDefault: 1,
                type: item.type,
                contactId: item.id,
                emailType: 1,
            });
        }
        const infoTels = Array.isArray(info.tels) ? info.tels : [];
        const infoMobiles = Array.isArray(info.mobiles) ? info.mobiles : [];
        const infoFaxes = Array.isArray(info.faxes) ? info.faxes : [];
        infoTels.forEach(val => {
            contactItemList.push({
                id: '',
                contactItemVal: val,
                contactItemRefer: '',
                contactItemType: 'TEL',
                isDefault: 0,
                type: item.type,
                contactId: item.id,
            });
        });
        infoMobiles.forEach(val => {
            contactItemList.push({
                id: '',
                contactItemVal: val,
                contactItemRefer: '',
                contactItemType: 'MOBILE',
                isDefault: 0,
                type: item.type,
                contactId: item.id,
            });
        });
        infoFaxes.forEach(val => {
            contactItemList.push({
                id: '',
                contactItemVal: val,
                contactItemRefer: '',
                contactItemType: 'FAX',
                isDefault: 0,
                type: item.type,
                contactId: item.id,
            });
        });
        return {
            contact,
            contactInfo: contactItemList,
        };
    }
    async testMemoryDataException() {
        return false;
    }
    handleSearchCondition(condition) {
        const searchExclude = condition.searchExclude || {};
        const searchInclude = condition.searchInclude || {};
        const { contactType, showDisable = true, isIM = false } = condition;
        const contactItemExclude = searchExclude.contactItem || [];
        const contactInclude = searchInclude.contact || [];
        const orgInclude = searchInclude.org || [];
        contactItemExclude.push({ key: 'contactItemType', val: 'yunxin' });
        if (isIM) {
            contactInclude.push({ key: 'enableIM', val: true });
        }
        if (!showDisable) {
            contactInclude.push({ key: 'visibleCode', val: 0 });
            orgInclude.push({ key: 'visibleCode', val: [0, 7] });
        }
        if (contactType) {
            contactInclude.push({ key: 'type', val: contactType });
        }
        searchExclude.contactItem = contactItemExclude;
        searchInclude.contact = contactInclude;
        searchInclude.org = orgInclude;
        condition.searchExclude = searchExclude;
        condition.searchInclude = searchInclude;
        return condition;
    }
    getSearchCondition(condition) {
        const { exclude, searchExclude, searchInclude, query, _account } = this.handleSearchCondition(condition);
        const tablesName = [
            this.ctx.contactUtil.contactTable,
            this.ctx.contactUtil.contactItemTable,
            this.ctx.contactUtil.orgTable,
            this.ctx.contactUtil.orgpathlistTable,
        ];
        const itemList = [
            {
                query,
                tableName: tablesName[0],
                hitName: 'contactName',
                select: 'id',
                orderByItem: ['contactName'],
                _account,
            },
            {
                query,
                tableName: tablesName[0],
                hitName: 'contactPYLabelName',
                select: 'id',
                orderByItem: ['contactPYLabelName'],
                _account,
            },
            {
                query,
                tableName: tablesName[0],
                hitName: 'contactPYName',
                select: 'id',
                orderByItem: ['contactPYName', 'accountName'],
                _account,
            },
            {
                query,
                tableName: tablesName[1],
                hitName: 'contactItemVal',
                aliasTableName: tablesName[0],
                select: 'contactId',
                orderByItem: ['contactItemVal', 'contactItemType'],
                _account,
            },
            {
                query,
                tableName: tablesName[2],
                hitName: 'orgName',
                select: 'id',
                orderByItem: ['parent', 'orgRank'],
                _account,
            },
            {
                query,
                tableName: tablesName[2],
                hitName: 'orgPYName',
                select: 'id',
                orderByItem: ['orgRank'],
                _account,
            },
        ];
        const searchList = [];
        itemList.forEach(item => {
            if (!(exclude === null || exclude === void 0 ? void 0 : exclude.includes(item.hitName))) {
                const _searchExclude = searchExclude && searchExclude[item.tableName];
                const _searchInclude = searchInclude && searchInclude[item.tableName];
                if (_searchExclude) {
                    item.exclude = _searchExclude;
                }
                if (searchInclude) {
                    item.include = _searchInclude;
                }
                searchList.push(item);
            }
        });
        return searchList;
    }
    async getSearchData(params) {
        const { query, tableName, exclude = [], include = [], orderByItem: orderBy, hitName, _account } = params;
        const reg = new RegExp(util.escapeRegex(query), 'i');
        console.time('[optimize]contactApi-searchGetAllData:' + query + ' ' + tableName);
        let res = await this.ctx.dbApi.getByEqCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName,
            _dbAccount: _account,
        });
        console.timeEnd('[optimize]contactApi-searchGetAllData:' + query + ' ' + tableName);
        console.time('[optimize]contactApi-searchFilterData:' + query + ' ' + tableName);
        res = res.filter((item) => reg.test(item[hitName]) && this.ctx.contactTrans.transExclude2FilterCondition(exclude, item) && this.ctx.contactTrans.transInclude2FilterCondition(include, item));
        const orderedData = this.setDataOrder({
            data: res,
            orderBy,
            query,
        });
        console.timeEnd('[optimize]contactApi-searchFilterData:' + query + ' ' + tableName);
        return orderedData;
    }
    async handleSearchList(searchList) {
        const result = {};
        const promiseList = searchList.map(search => this.getSearchData(search));
        console.time('[optimize]contactAPI-searchContact:' + searchList[0].query);
        const data = await Promise.all(promiseList);
        console.timeEnd('[optimize]contactAPI-searchContact:' + searchList[0].query);
        console.time('[optimize]contactAPI-loopContact:' + searchList[0].query);
        searchList.forEach((search, index) => {
            const list = data[index];
            const { select } = search;
            const tableName = search.aliasTableName || search.tableName;
            const selectList = result[tableName] || new Set();
            list.forEach((item) => {
                selectList.add(item[select]);
            });
            result[tableName] = selectList;
        });
        console.timeEnd('[optimize]contactAPI-loopContact:' + searchList[0].query);
        return result;
    }
    getContactBySearch(condition) {
        const searchCondition = this.getSearchCondition(condition);
        return this.handleSearchList(searchCondition);
    }
    getSearchFilter() {
        return (item, params) => {
            if (!params || !params.additionalData || !params.additionalData.searchFilterList) {
                return false;
            }
            return params.additionalData.searchFilterList.every(({ val: _val, key: _key, type: _type }) => {
                if (Array.isArray(_key) && (!Array.isArray(_type) || !Array.isArray(_val))) {
                    throw new Error('过滤key为list,val,type,必须一一对应');
                }
                let keyList;
                let typeList;
                let valList;
                if (!Array.isArray(_key)) {
                    keyList = [_key];
                    typeList = [_type];
                    valList = [_val];
                }
                else {
                    keyList = _key;
                    typeList = _type;
                    valList = _val;
                }
                const precompiledRegexList = valList.map((val, i) => {
                    if (typeList[i] !== 'match')
                        return null;
                    if (Array.isArray(val)) {
                        return val.map(v => new RegExp(util.escapeRegex(v.toString()), 'i'));
                    }
                    return new RegExp(util.escapeRegex(val.toString()), 'i');
                });
                return keyList.some((curKey, i) => {
                    const data = item[curKey];
                    const type = typeList[i];
                    if (type === 'match') {
                        const compiled = precompiledRegexList[i];
                        if (!compiled)
                            return false;
                        if (Array.isArray(data)) {
                            if (Array.isArray(compiled)) {
                                return compiled.some(re => data.some((d) => re.test(d)));
                            }
                            return data.some((d) => compiled.test(d));
                        }
                        if (Array.isArray(compiled)) {
                            return compiled.some(re => re.test(data));
                        }
                        return compiled.test(data);
                    }
                    const val = valList[i];
                    const valArr = Array.isArray(val) ? val : [val];
                    if (type === 'equal') {
                        return valArr.includes(data);
                    }
                    if (type === 'notEqual') {
                        return !valArr.includes(data);
                    }
                    return false;
                });
            });
        };
    }
    searchTable(params) {
        var _a;
        const { searchFilterList, _account, tableName, filterLimit, lastId, dbName, noRelateEnterprise = false } = params;
        const isMainAccount = !_account || _account === (((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '');
        let filterList = [];
        if (!isMainAccount) {
            filterList = [contactCommonSearchFilterName];
        }
        else if (noRelateEnterprise) {
            filterList = [contactCommonSearchFilterName, contactGrepRelateEnterpriseFilterName];
        }
        else {
            filterList = [contactCommonSearchFilterName, contactGrepInvalidEnterpriseFilterName];
        }
        const rangeCondition = {
            dbName: dbName || this.ctx.contactUtil.contactDbName,
            tableName,
            adCondition: {
                type: 'above',
                args: [lastId || 0],
                field: 'id',
            },
            filter: filterList,
            useDexieFilter: false,
            additionalData: {
                searchFilterList,
            },
            _dbAccount: _account,
            filterLimit,
        };
        if (noRelateEnterprise) {
            rangeCondition.additionalData.needGrepRelateEnterpriseResult = true;
            rangeCondition.additionalData.enterpriseFieldName = 'enterpriseId';
        }
        return this.ctx.dbApi.getByRangeCondition(rangeCondition);
    }
    transMemorySearchCondition(condition) {
        const { query, contactType, exclude, searchInclude } = condition;
        const contactFilterList = [];
        const orgFilterList = [];
        if (contactType) {
            contactFilterList.push({
                key: 'type',
                val: contactType,
                type: 'equal',
            });
        }
        const searchTableMap = {
            contact: {
                tableName: 'contact',
                searchFilterList: contactFilterList,
                searchKey: 'id',
            },
            org: {
                tableName: 'org',
                searchFilterList: orgFilterList,
                searchKey: 'id',
            },
        };
        if (searchInclude) {
            Object.keys(searchTableMap).forEach(tableName => {
                const tableConfig = searchTableMap[tableName];
                if (!tableConfig) {
                    return;
                }
                const tableInclude = searchInclude[tableName] || [];
                tableInclude.forEach(({ key, val }) => {
                    tableConfig.searchFilterList.push({
                        key,
                        val,
                        type: 'equal',
                    });
                });
            });
        }
        const defaultFilterMap = {
            contact: new Set(['contactName', 'contactPYName', 'contactPYLabelName', 'accountName', 'emails']),
            org: new Set(['orgName', 'orgPYName']),
        };
        const searchList = [];
        exclude === null || exclude === void 0 ? void 0 : exclude.forEach(item => {
            Object.values(defaultFilterMap).forEach(defaultFilter => {
                defaultFilter.delete(item);
            });
        });
        const defaultFilterKeysList = Object.keys(defaultFilterMap);
        defaultFilterKeysList.forEach(item => {
            const filterSet = defaultFilterMap[item];
            const searchItem = searchTableMap[item];
            if (filterSet && filterSet.size > 0 && searchItem) {
                const searchFilterList = searchItem.searchFilterList || [];
                const keys = [...filterSet];
                searchFilterList.push({
                    key: keys,
                    val: keys.map(() => query),
                    type: keys.map(() => 'match'),
                });
                searchItem.searchFilterList = searchFilterList;
                searchList.push(searchItem);
            }
        });
        return searchList;
    }
    transSearchCondition(condition) {
        const { query, contactType, showDisable = true, isIM, exclude, filter, searchExclude, searchInclude } = condition;
        const contactFilterList = [];
        const contactItemFilterList = [];
        const orgFilterList = [];
        contactItemFilterList.push({
            key: 'contactItemType',
            val: 'yunxin',
            type: 'notEqual',
        });
        if (contactType) {
            contactFilterList.push({
                key: 'type',
                val: contactType,
                type: 'equal',
            });
            contactItemFilterList.push({
                key: 'type',
                val: contactType,
                type: 'equal',
            });
        }
        if (isIM) {
            contactFilterList.push({
                key: 'enableIM',
                val: true,
                type: 'equal',
            });
        }
        if (!showDisable) {
            contactFilterList.push({
                key: 'visibleCode',
                val: 0,
                type: 'equal',
            });
            orgFilterList.push({
                key: 'visibleCode',
                val: [0, 7],
                type: 'equal',
            });
        }
        const searchTableMap = {
            contact: {
                tableName: 'contact',
                searchFilterList: contactFilterList,
                searchKey: 'id',
            },
            contactItem: {
                tableName: 'contactItem',
                searchFilterList: contactItemFilterList,
                searchKey: 'contactId',
            },
            org: {
                tableName: 'org',
                searchFilterList: orgFilterList,
                searchKey: 'id',
            },
        };
        Object.values(searchTableMap).forEach(item => {
            if (filter) {
                const tableExclude = filter[item.tableName] || [];
                tableExclude.forEach(({ key, val }) => {
                    item.searchFilterList.push({
                        key,
                        val,
                        type: 'notEqual',
                    });
                });
            }
            if (searchExclude) {
                const tableExclude = searchExclude[item.tableName] || [];
                tableExclude.forEach(({ key, val }) => {
                    item.searchFilterList.push({
                        key,
                        val,
                        type: 'notEqual',
                    });
                });
            }
            if (searchInclude) {
                const tableInclude = searchInclude[item.tableName] || [];
                tableInclude.forEach(({ key, val }) => {
                    item.searchFilterList.push({
                        key,
                        val,
                        type: 'equal',
                    });
                });
            }
        });
        const defaultFilterMap = {
            contact: new Set(['contactName', 'contactPYName', 'contactPYLabelName']),
            contactItem: new Set(['contactItemVal']),
            org: new Set(['orgName', 'orgPYName']),
        };
        const searchList = [];
        exclude === null || exclude === void 0 ? void 0 : exclude.forEach(item => {
            Object.values(defaultFilterMap).forEach(defaultFilter => {
                defaultFilter.delete(item);
            });
        });
        const defaultFilterKeysList = Object.keys(defaultFilterMap);
        defaultFilterKeysList.forEach(item => {
            const filterSet = defaultFilterMap[item];
            const searchItem = searchTableMap[item];
            if (filterSet && filterSet.size > 0 && searchItem) {
                const searchFilterList = searchItem.searchFilterList || [];
                const keys = [...filterSet];
                searchFilterList.push({
                    key: keys,
                    val: keys.map(() => query),
                    type: keys.map(() => 'match'),
                });
                searchItem.searchFilterList = searchFilterList;
                searchList.push(searchItem);
            }
        });
        return searchList;
    }
    async getContactBySearch2(params) {
        const tableCondition = this.transSearchCondition(params);
        const { _account, maxItem = this.ctx.contactUtil.searchTableLimit, lastId, noRelateEnterprise = false } = params;
        const promiseList = tableCondition.map(condition => {
            const { tableName, searchFilterList, searchKey, returnList } = condition;
            return this.searchTable({
                searchFilterList,
                tableName,
                _account,
                filterLimit: maxItem,
                lastId,
                noRelateEnterprise,
            }).then(async (list) => {
                const idSet = new Set();
                const idMap = {};
                list.forEach(item => {
                    idSet.add(item[searchKey]);
                    if (returnList) {
                        const arr = idMap[item[searchKey]] || [];
                        arr.push(item);
                        idMap[item[searchKey]] = arr;
                    }
                    else {
                        idMap[item[searchKey]] = item;
                    }
                });
                return {
                    [tableName]: {
                        idSet,
                        idMap,
                    },
                };
            });
        });
        const data = await Promise.all(promiseList);
        let res = {};
        data.forEach(item => {
            res = Object.assign(Object.assign({}, res), item);
        });
        return res;
    }
    getFlatStrOrArrInfo(arr, type, rs) {
        const newArr = [];
        arr.forEach((val) => {
            const res = rs ? Object.assign({}, rs) : {};
            if (type) {
                res.contactItemType = type;
                res.isDefault = 1;
            }
            try {
                if (val.startsWith('[') && val.endsWith(']')) {
                    const arr = JSON.parse(val);
                    arr.forEach((a) => {
                        if (type) {
                            res.contactItemVal = a;
                            newArr.push(res);
                        }
                        else {
                            newArr.push(a);
                        }
                    });
                }
                else if (type) {
                    res.contactItemVal = val;
                    newArr.push(res);
                }
                else {
                    newArr.push(val);
                }
            }
            catch (e) {
                console.error('[contact] getFlatStrOrArrInfo', e);
                newArr.push(val);
            }
        });
        return newArr;
    }
    async getContactByItemOld(condition) {
        const { type, value, filterType, _account, showDisable } = condition;
        const adCondition = {
            type: 'anyOf',
            args: [value],
            field: 'contactItemVal',
        };
        const contactItemList = await this.ctx.dbApi.getByRangeCondition({
            adCondition,
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.contactItemTable,
            additionalData: {
                type,
                filterType,
            },
            filter: contactMultiTypeFilterName,
            useDexieFilter: false,
            _dbAccount: _account,
        });
        if (!contactItemList || !contactItemList.length) {
            return {};
        }
        const contactIds = new Set(contactItemList.map(item => item.contactId));
        const contactList = await this.getContactList({
            idList: [...contactIds],
            _account,
            showDisable,
        });
        if (!contactList || !contactList.length) {
            return {};
        }
        const validContactMap = new Map();
        contactList.forEach(item => {
            if (condition.isIM && !item.enableIM) {
                return;
            }
            if (condition.filterType && item.type !== filterType) {
                return;
            }
            validContactMap.set(item.id, item);
        });
        if (!validContactMap.size) {
            return {};
        }
        const validContactItemList = await this.getContactItemListByContactId({ idList: [...validContactMap.keys()], _account });
        const contactItemMap = lodashGroupby(validContactItemList, item => item.contactId);
        return [...validContactMap.keys()].reduce((total, contactId) => {
            if (!Reflect.has(contactItemMap, contactId)) {
                return total;
            }
            total[contactId] = {
                contact: validContactMap.get(contactId),
                contactInfo: contactItemMap[contactId],
            };
            return total;
        }, {});
    }
    async getContactByItemWithChunked(condition) {
        const { type, value, filterType, _account } = condition;
        let contactModelMap = {};
        await lodashChunk(value, 2000).reduce((total, chunkedIds) => {
            total = total
                .then(() => this.getContactByItemOld({
                type,
                value: chunkedIds,
                filterType,
                _account,
            }))
                .then(chunkedContactModel => {
                contactModelMap = Object.assign(contactModelMap, chunkedContactModel);
                return true;
            });
            return total;
        }, Promise.resolve(true));
        return contactModelMap;
    }
    async getContactSimpleModelByItem(condition) {
        const { value, _account } = condition;
        const adCondition = {
            type: 'anyOf',
            args: [value],
            field: 'accountName',
        };
        const entityContactList = await this.ctx.dbApi.getByRangeCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.contactTable,
            adCondition,
            _dbAccount: _account,
        });
        return entityContactList.reduce((total, entityContact) => {
            total[entityContact.id] = {
                contact: entityContact,
                contactInfo: [
                    {
                        contactId: entityContact.id,
                        contactItemVal: entityContact.accountName,
                        contactItemType: 'EMAIL',
                        isDefault: 1,
                        contactItemRefer: '',
                        type: entityContact.type,
                        _lastUpdateTime: entityContact._lastUpdateTime,
                        id: util.getUnique(entityContact.id, entityContact.accountName),
                    },
                ],
            };
            return total;
        }, {});
    }
    async getContactSimpleModelByItemWithChunked(condition) {
        const { type, value, filterType, _account } = condition;
        let contactModelMap = {};
        await lodashChunk(value, 2000).reduce((total, chunkedIds) => {
            total = total
                .then(() => this.getContactSimpleModelByItem({
                type,
                value: chunkedIds,
                filterType,
                _account,
            }))
                .then(chunkedContactModel => {
                contactModelMap = Object.assign(contactModelMap, chunkedContactModel);
                return true;
            });
            return total;
        }, Promise.resolve(true));
        return contactModelMap;
    }
    async getContactByItem(condition) {
        if (!lodashGet(condition, 'type.length', 0) || !lodashGet(condition, 'value.length', 0)) {
            return [];
        }
        if (condition.type === 'EMAIL') {
            condition.value = (condition.value || []).map(item => `${item}`.toLocaleLowerCase());
        }
        let contactModelMap = {};
        try {
            const queryType = lodashGet(condition, 'generateContactModelType', 'oldModel');
            if (queryType === 'chunked') {
                contactModelMap = await this.getContactByItemWithChunked(condition);
            }
            else if (queryType === 'simpleModel') {
                contactModelMap = await this.getContactSimpleModelByItemWithChunked(condition);
            }
            else {
                contactModelMap = await this.getContactByItemOld(condition);
            }
        }
        catch (ex) {
            console.error('getContactByItem Error', ex, condition);
        }
        return contactModelMap ? Object.values(contactModelMap) : [];
    }
    async getContactByYunxin(accounts, showDisable) {
        let contactList = [];
        try {
            if (!(accounts === null || accounts === void 0 ? void 0 : accounts.length)) {
                return contactList;
            }
            const adCondition = {
                type: 'anyOf',
                args: [accounts],
                field: 'contactItemVal',
            };
            const contactItemList = (await this.ctx.dbApi.getByRangeCondition({
                adCondition,
                dbName: this.ctx.contactUtil.contactDbName,
                tableName: this.ctx.contactUtil.contactItemTable,
                filter: contactIMFilterName,
                useDexieFilter: false,
            }));
            if (contactItemList && contactItemList.length > 0) {
                const idList = util.getKeyListByList(contactItemList, 'contactId');
                contactList = await this.getContactList({
                    idList,
                    isIM: true,
                    showDisable,
                });
            }
        }
        catch (error) {
            console.error('getContactByYunxin Error', error, accounts);
        }
        return contactList;
    }
    async getTotalLokiData(options) {
        const { tableName, enableProxy = true, _account } = options;
        if (typeof tableName !== 'string' || !tableName.length) {
            return [];
        }
        if (!enableProxy) {
            this.ctx.contactUtil.forbiddenBridgeOnce();
        }
        return this.ctx.dbApi.getByEqCondition({
            dbName: 'contact_search',
            tableName,
            _dbAccount: _account,
        });
    }
    async writeLxInfo(rows, _account) {
        if (!rows.length) {
            return;
        }
        const dbAccount = _account || this.ctx.contactUtil.getCurrentAccount();
        try {
            await this.ctx.dbApi.putAll({ dbName: this.ctx.contactUtil.contactDbName, tableName: 'lx_info', _dbAccount: dbAccount }, rows, { supportCache: 'disable' }, dbAccount);
        }
        catch (e) {
            console.warn('[contact_dbl_search] writeLxInfo error', e);
        }
    }
    async readLxInfoByIds(contactIds, _account) {
        if (!contactIds.length) {
            return [];
        }
        const dbAccount = _account || this.ctx.contactUtil.getCurrentAccount();
        try {
            return await readLxInfoFromLoki(this.ctx.lokiApi, contactIds, dbAccount);
        }
        catch (e) {
            console.warn('[contact_dbl_search] readLxInfoByIds error', e);
            return [];
        }
    }
}
